import * as yup from 'yup';

import { validators } from './utilities';

/**
 * Validation schema for Batch Rate Request form fields
 * Maps to RateQuality ShipmentDataToRate.cs batch input format
 */
export const batchFieldSchema = {
  // Results file name
  fileName: yup.string().max(10, 'File name prefix must be 10 characters or fewer').required('File name prefix is required'),

  // Shipment data upload (Excel file with shipment rows)
  shipmentsFileUpload: yup
    .array()
    .of(yup.mixed<File>().required('File is required'))
    .required('Shipment file is required'),

  // BG Rating Accounts - multiple accounts for batch rating (max 4)
  accounts: yup
    .array()
    .of(
      yup.object({
        name: yup.string().required(),
        enterpriseID: yup.number().required(),
        accountNumber: yup.string().required(),
      })
    )
    .min(1, 'At least one account is required')
    .max(4, 'Maximum of 4 accounts allowed')
    .required('At least one account is required'),

  // Rate return options (what types of rates to return)
  returnCustomerRates: yup.boolean().default(true),
  returnLiveContractRates: yup.boolean().default(true),
  returnProposalContractRates: yup.boolean().default(false),
  returnVolumeRates: yup.boolean().default(false),

  // Optional targeted carriers (filter to specific SCACs)
  targetedCarriers: validators.carrierList,

  // Notification emails
  notifyEmails: yup
    .array(
      yup
        .object({
          value: validators.blugraceEmail.required(),
        })
        .required()
    )
    .required(),
};
